const CONNECTOR_WORDS = new Set([
  "and",
  "then",
  "thus",
  "so",
  "therefore",
  "next",
  "finally",
  "also",
  "now",
  "let",
]);

const stripHintLabels = (text) => {
  return String(text || "")
    .split(/\r?\n/)
    .map((line) => line.replace(/^\s*(Focus|Try|Check)\s*:\s*/i, "").trimEnd())
    .filter((line) => line.length > 0)
    .join("\n");
};

export const formatHintText = (text) => {
  const rawLines = stripHintLabels(text)
    .split(/\r?\n/)
    .map((line) => line.replace(/[ \t]+/g, " ").trim());
  const cleaned = [];

  const stripLeadingMarkers = (line) =>
    line.replace(/^[-*+]\s+/, "").replace(/^\.+\s*/, "").trim();

  const isConnectorOnly = (line) => {
    const lettersOnly = line.toLowerCase().replace(/[^a-z]/g, "");
    return CONNECTOR_WORDS.has(lettersOnly);
  };

  for (let index = 0; index < rawLines.length; index += 1) {
    let line = rawLines[index];
    if (!line) continue;
    line = stripLeadingMarkers(line);
    if (!line) continue;

    if (isConnectorOnly(line)) {
      const connector = line.replace(/[^A-Za-z]/g, "");
      let nextIndex = index + 1;
      while (nextIndex < rawLines.length && !rawLines[nextIndex]) {
        nextIndex += 1;
      }
      if (nextIndex < rawLines.length) {
        const nextLine = stripLeadingMarkers(rawLines[nextIndex]);
        rawLines[nextIndex] = `${connector} ${nextLine}`.trim();
      } else if (cleaned.length) {
        cleaned[cleaned.length - 1] = `${cleaned[cleaned.length - 1]} ${connector}`.trim();
      }
      continue;
    }

    cleaned.push(line);
  }

  return cleaned.join("\n").trim();
};

export default formatHintText;
